// Import polyfills first for older browser compatibility
import './polyfills.js';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { ErrorBoundary } from './ErrorBoundary';
import './index.css';
import './shine.css';
import './fonts';

// Fallback: enforce notranslate attributes at runtime (some translators ignore meta on initial load)
try {
  document.documentElement.setAttribute('translate', 'no');
  document.documentElement.classList.add('notranslate');
  document.body?.setAttribute('translate', 'no');
} catch {}

// Service worker. En PRODUCCIÓN lo registramos (PWA installability). En DEV
// lo DESREGISTRAMOS y borramos todos los caches: un SW viejo de un build
// anterior (que sí cacheaba) puede seguir sirviendo assets cacheados y hacer
// que NO se vean los cambios aunque el dev server sirva código nuevo.
if ('serviceWorker' in navigator) {
  if (import.meta.env.DEV) {
    navigator.serviceWorker
      .getRegistrations()
      .then((regs) => regs.forEach((r) => r.unregister()))
      .catch(() => {});
    if ('caches' in window) {
      caches
        .keys()
        .then((keys) => keys.forEach((k) => caches.delete(k)))
        .catch(() => {});
    }
  } else {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    });
  }
}

// Capture beforeinstallprompt early — the event fires once at page load
// and is lost if no listener exists. Store it globally for the React hook.
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  (window as any).__pwaInstallPrompt = e;
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);